import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    clientHead: { width: '80%' },
    configHeader: { marginTop: 16 },
    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    alarmIcon: {
      width: 15,
      height: 15,
    },
    flag: {
      display: 'block',
      textAlign: 'center',
      color: palette.blue,
      border: `1px solid ${palette.blue}`,
      borderRadius: 5,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    flagPink: {
      borderColor: palette.pink,
      color: palette.pink,
      textTransform: 'capitalize',
    },
    flagGreen: {
      borderColor: palette.green,
      color: palette.green,
      textTransform: 'capitalize',
    },
    messageStopServer: {
      textAlign: 'center',
      fontSize: 12,
    },
    alert: {
      '& b': {
        fontWeight: 600,
      },
    },
    serverType: {
      marginBottom: 16,
    },
    iconReload: {
      marginRight: 5,
    },
    statusText: {
      fontSize: 12,
    },
    searchIcon: {
      color: palette.gray,
      margin: '0px 12px',
      opacity: 0.5,
      fontSize: 20,
    },
    actions: { marginBottom: 8 },
    longField: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
    },
    menuOptions: {
      fontSize: 12,
      fontWeight: 500,
    },
    center: {
      textAlign: 'center',
    },
    imageCell: { whiteSpace: 'nowrap' },
    iconLock: { height: 16, cursor: 'pointer' },
    buttonsBlockServerActions: { margin: '8px 0px' },
    blockActionsDescription: { fontSize: 12 },
    alertText: { fontSize: 14 },
    alertBlock: {
      width: '100%',
      '& b': {
        fontWeight: 600,
      },
      '& .MuiAlert-message': { width: '100%' },
    },
    lockIcon: { fontSize: 20 },
    menuActionsAndLock: { display: 'flex', justifyContent: 'center' },
    alertModal: {
      width: 'fit-content',
      margin: 16,
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    alertModalText: { fontSize: 12 },
    reasonField: {
      '& .MuiOutlinedInput-root': { height: 'auto' },
      '& .MuiOutlinedInput-multiline': { padding: 14 },
    },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: 600,
    overflowX: 'auto',
  },
};

export const overrideOptimizedModal = {
  content: {
    overflow: 'hidden',
    padding: 16,
    fontSize: '12px !important',
  },
};
export const overrideHistoryOptimizedModal = {
  content: {
    overflow: 'hidden',
    padding: 16,
    fontSize: '12px !important',
    minWidth: 1200,
  },
};

export const overrideModalBlockActions = {
  content: {
    padding: '12px 0px 12px 12px',
    fontSize: '12px !important',
    maxHeight: 470,
    overflow: 'hidden',
  },
};
